import React, { useEffect, useState } from "react";
import i18next from "i18next";

import PartnerReferenceBlock from "components/forms/formBlocks/PartnerReferenceBlock";
import PipedriveMetadataBlock from "components/forms/formBlocks/PipedriveMetadataBlock";
import AdditionalInformationBlock from "components/forms/formBlocks/AdditionalInformationBlock";
import AssetBlock from "components/forms/formBlocks/AssetBlock";
import BusinessCustomerInformationBlock from "components/forms/formBlocks/BusinessCustomerInformationBlock";
import LeasingCalculatorBlock from "components/forms/formBlocks/LeasingCalculatorBlock";
import DataProcessingConsentBlock from "components/forms/formBlocks/DataProcessingConsentBlock";
import SubmitButton from "components/forms/formElements/SubmitButton";

import { getLegalTexts } from "services/legalService";
import { APPLICANT_TYPES, PRODUCT_TYPES } from "services/formService";
import MarketingConsentBlock from "../formBlocks/MarketingConsentBlock";
import FileUploadBlock from "components/forms/formBlocks/FileUploadBlock";

const BusinessLeasingForm = ({
  formInstance,
  formMode = undefined,
  prefill = false,
  formModeLoading = false,
  formModePreview = false,
}) => {
  const language = i18next.language;

  const [legalTexts, setLegalTexts] = useState({});
  const [consent, setConsent] = useState();

  useEffect(() => {
    (async () => {
      const legalData = await getLegalTexts(language);
      if (!legalData) {
        return;
      }

      const fetchLegalItem = (title) => {
        return legalData.find((item) => item.title === title)?.body?.[0]?.value;
      };

      setLegalTexts({
        propertyValue: fetchLegalItem("LeasingForm Info Property value"),
        propertyInsurance: fetchLegalItem("LeasingForm Info Property Insurance"),
        confirmation: fetchLegalItem("LeasingForm Confirmation"),
        marketingConsent: fetchLegalItem("LeasingForm Marketing Consent"),
        marketingConsentDetailed: fetchLegalItem("LeasingForm Marketing Consent Detailed Business"),
      });
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  // render
  return (
    <>
      <LeasingCalculatorBlock
        formInstance={formInstance}
        editable={APPLICANT_TYPES.isPartner(formMode)}
        readOnly={APPLICANT_TYPES.isDefault(formMode) || formModePreview}
      />

      <BusinessCustomerInformationBlock formInstance={formInstance} readOnly={formModePreview} prefill={prefill} />

      <AssetBlock
        formInstance={formInstance}
        feeTooltip={legalTexts.propertyValue}
        insuranceTooltip={legalTexts.propertyInsurance}
        readOnly={formModePreview}
      />

      <AdditionalInformationBlock readOnly={formModePreview} />

      <FileUploadBlock
        readOnly={formModePreview}
        formInstance={formInstance}
        productType={PRODUCT_TYPES.LEASING_FINANCE_BUSINESS}
      />

      <DataProcessingConsentBlock
        consent={consent}
        onConsentChange={setConsent}
        innerHtml={legalTexts.confirmation}
        readOnly={formModePreview}
      />

      <MarketingConsentBlock
        hidden={APPLICANT_TYPES.isDefault(formMode)}
        innerHtml={legalTexts.marketingConsent}
        infoHtml={legalTexts.marketingConsentDetailed}
        readOnly={formModePreview}
      />

      {APPLICANT_TYPES.isDefault(formMode) && <PipedriveMetadataBlock />}
      {APPLICANT_TYPES.isPartner(formMode) && <PartnerReferenceBlock />}

      {!formModePreview &&
        (prefill ? (
          <SubmitButton textTranslationId="prefillFormSubmitButton" loading={formModeLoading} />
        ) : (
          <SubmitButton enabled={consent} loading={formModeLoading} />
        ))}
    </>
  );
};

export default BusinessLeasingForm;
